import React from 'react';
import type { ReactNode } from 'react';
import './CustomModal.css';

interface CustomModalProps {
  show: boolean;
  children: ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({ show, children }) =>
{
  return (
    <div className={`custom-modal ${show ? 'display-block' : 'display-none'}`}>
      <section className="custom-modal-main">{children}</section>
    </div>
  );
};

export default CustomModal;
